module.exports = __webpack_public_path__ + "static/media/frdlian.79d1a581.gif";